import { Fragment, useContext } from "react"
import type { ListBank } from "../../../../../types"
import { Toggle } from "components/actions/Toggle"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { Render } from "../../../../../utils"


export function IsActive(props: {
    id: ListBank
    refetch?: () => void
}) {
    const api = useApi()
    const { toggle } = useContext(Render)

    const onSubmit = (value: ListBank) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.put("/acctype/changestatus",
                    {
                        account_type_id: value.account_type_id,
                        statusdel: !value.is_deleted
                    }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => {
                        if (err.response && err.response.status === 400) {
                            return err.response.data.message || "Bad Request";
                        } else {
                            return "An error occurred";
                        }
                    }
                }
            ).then(() => {
                toggle()
                props?.refetch && props.refetch()
            }).catch(() => {}).finally(resolve)
        })
    }

    return (
        <Fragment>
            <Toggle 
                isChecked={props.id.is_deleted} 
                onClick={() => {
                    onSubmit(props.id);
                }} />
        </Fragment>
    )
}